import classes from './Menu.module.css';
import React from 'react';
import {
    Route,
    Routes,
    NavLink,
    BrowserRouter
} from "react-router-dom";
import Home from "./Home";
import Hungarian from './Hungarian';
import Information from "./Information";
import {Contacts, address, sendEmail} from "./Contacts";


const Menu = () => {
    const mailtoHref = `mailto:${address.join('')}?subject=Business Inquiry&body=Hi`;

    return (
        <BrowserRouter>
            <h1>.rq Lab</h1>
            <div className={classes.Menu}>
                <nav aria-label="Primary">
                    <ul className={classes.Menu_header}>
                        <li><NavLink to="/">Home</NavLink></li>
                        <li><NavLink to="/information">Information</NavLink></li>
                        <li><a href="https://pdf.roamingquark.info">Join PDFs</a></li>
                        <li><NavLink to="/hungarian">Hungarian</NavLink></li>
                        <li><NavLink to="/contacts">Contacts</NavLink></li>
                    </ul>
                </nav>
                <main className={classes.Content}>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/information" element={<Information />}/>
                        <Route path="/hungarian" element={<Hungarian />}/>
                        <Route path="/contacts" element={<Contacts />}/>
                    </Routes>
                </main>
                <div className={classes.Footer}>
                    © 2025 .rq Lab. Business inquiries:
                    <a href={mailtoHref} className="cryptedmail"
                                data-name={address[0]}
                                data-domain={address[2]+address[3]}
                                data-tld={address[5]}
                                onClick={sendEmail}> Email</a>
                </div>
            </div>
        </BrowserRouter>
    )
}

export default Menu;